import React from "react"
import { Link, graphql } from "gatsby"
import "bootstrap/dist/css/bootstrap.css"
import "./index.css"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Sidebar from "../components/sidebar/Sidebar"
import TechTag from "../components/tags/TechTag"

const ArchivePage = ({ data }) => {
  const posts = data.allMarkdownRemark.edges
  const labels = data.site.siteMetadata.labels
  
  const getTechTags = (tags) => {
    const techTags = []
    tags.forEach((tag, i) => {
      labels.forEach((label) => {
        if (tag === label.tag) {
          techTags.push(<TechTag key={i} tag={label.tag} tech={label.tech} name={label.name} size={label.size} color={label.color} />)
        }
      })
    })
    return techTags
  }
  
  
  return (
    <Layout>
    <SEO title="Archive" keywords={[`gatsby`, `javascript`, `react`, `web development`, `blog`, `graphql`]} />
    <div className="index-main">
    <div className="sidebar px-4 py-2">
    <Sidebar />
    </div>
    <div className="post-list-main">
    <h1 className="fixed-top text-right muted-display">ARCHIVE</h1>
    <h2 className="heading mt-5 border-bottom pb-3">ARCHIVE</h2>
    {posts.map((post) => {
            const tags = post.node.frontmatter.tags
            return (
                <Link to={post.node.fields.slug} className="text-dark container post-card">
                  <div key={post.node.id} className="py-3 bg-light border shadow-lg">
                  <h2 className="title mb-2 text-dark">{post.node.frontmatter.title}</h2>
                  <small className="d-block text-primary mb-3"><i>{post.node.frontmatter.date}에 게시됨</i></small>
                  <div className="m-1">
                    <p className="mt-3 d-inline">{post.node.excerpt}</p>
                  </div>
                  <div className="d-block mt-3">
                    {getTechTags(tags)}
                  </div>
                  </div>
                  </Link>)})}
      </div>
      </div>
      </Layout>
      )
    }
    
    export const pageQuery = graphql`
    query ArchiveQuery {
      site {
        siteMetadata {
          title 
          author
          labels {
            tag
            tech 
            name 
            size 
            color
          } 
        }
      }
      allMarkdownRemark(
        limit: 1000
        sort: { fields: [frontmatter___date], order: DESC }
        filter: { frontmatter: { published: { eq: true } }, id: {nin: "5dca3d6f-52db-5c6a-a4a5-75fa9aa18d09"} }
        ) {
          totalCount
          edges {
            node {
              excerpt(pruneLength: 200)
              html
              id
              frontmatter {
                title
                date(formatString: "MMMM DD, YYYY")
                tags
              }
              fields {
                slug
              }
            }
          }
        }
      }
      `
      
      export default ArchivePage
      
      